import './Chart_analysis.scss';
import React, { useState, useEffect } from "react";
import { FiBarChart2 } from 'react-icons/fi';
import HeaderTitle from "../comm/HeaderTitle";
import fnc from "../mymod/commFunction";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, } from "recharts";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import { useDispatch, useSelector } from "react-redux";
import { setHeaderInfo, setHeader_dev } from "../reduxToolkit/redux";

const AnalysisTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="analysis-tooltip">
      <strong>{label}</strong>
      {payload.map((entry) => (
        <div key={entry.dataKey}>
          <i style={{ backgroundColor: entry.dataKey === '점수' ? '#7662ed' : '#4fc7af' }} />
          <span>{entry.dataKey}</span>
          <em>{Number(entry.value).toFixed(1)}점</em>
        </div>
      ))}
    </div>
  );
};

const formatAreaName = (value) => {
  const text = String(value || '기타');
  return text.length > 7 ? `${text.slice(0, 7)}…` : text;
};


const Chart_analysis = ({ selectedListItem, setIsModal }) => {
 
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [dataList, setDataList] = useState([]);
  const [dataListAvg, setDataListAvg] = useState([]);

  const lmsListCode = useSelector(state => state.reduxStore.lmsListCode);


  useEffect(() => {
    fncSelect_analysis_testGroup();
  }, []);

  useEffect(() => {
    if (dataListAvg.length > 0) {
      fncSelect_analysis_st();
    }
  }, [dataListAvg]);
  


  const fncSelect_analysis_testGroup = () => {
    const acaCode = fnc.getCookie('acaCode');

    fnc.sendAxios("/kuesbChartRoutes/select/alalysis_testGroup", {  acaCode, parentCode: lmsListCode  }, (res) => {
      if (Array.isArray(res) ) {
        setDataListAvg(res);
      } else {
        console.log(res, "/kuesbChartRoutes/select/alalysis_testGroup");
      }
    });
  };
  
  const fncSelect_analysis_st = () => {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');

    fnc.sendAxios("/kuesbChartRoutes/select/alalysis_st", {  acaCode, stCode, parentCode: lmsListCode  }, (res) => {
      if (res) {
        if(dataListAvg.length > 0) {
          const data = fncGet_analysisData_st(res);
          setDataList(data);
        }
      } else {
        console.log(res, "/kuesbChartRoutes/select/alalysis_st");
      }
    });
  };

  
  function fncGet_analysisData_st(res) {//O의 개수가 0인 경우도 포함
    // 시각화에 사용할 데이터 변환
    const simplifiedData = res.map(({ item, avg }) => {
      // dataListAvg에서 해당 item의 평균(avg)을 찾음
      const avgData = dataListAvg.find(avgItem => avgItem.item === item);
      return {
        name: item,
        점수: avg.toFixed(1),
        평균: avgData ? avgData.avg.toFixed(1) : 0 // 평균이 없으면 기본값 0
      };
    });
  
    return simplifiedData;
  }
  


  //===================================================================================

  const fncSelect_analysis = () => {//이 방식 사용 안 함 sql에서 평균 처리 일단 지우지 말자
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');

    fnc.sendAxios("/kuesbChartRoutes/select/alalysis", {  acaCode, stCode, parentCode: lmsListCode  }, (res) => {
      if (res) {
        if(dataListAvg.length > 0) { 
          const data = fncGet_analysisData(res);
          setDataList(data);
        }
      } else {
        console.log(res, "/kuesbChartRoutes/select/alalysis");
      }
    });
  };


  function fncGet_analysisData(res) {//O의 개수가 0인 경우도 포함
    // 전체 item 개수 계산
    const itemCounts = res.reduce((acc, entry) => {
      acc[entry.item] = (acc[entry.item] || 0) + 1; // item별 전체 개수 계산
      return acc;
    }, {});
  
    // 맞은 개수 계산
    const correctCounts = res.reduce((acc, entry) => {
      if (entry.OX === "O") {
        acc[entry.item] = (acc[entry.item] || 0) + 1; // item별 정답 개수 누적
      }
      return acc;
    }, {});
  
    // 모든 item을 포함하는 초기 데이터 생성
    const allItems = [...new Set(res.map(entry => entry.item))]; // 모든 고유 item 추출
    const scoresByItemValue = allItems.map(item => ({
      item,
      totalScore: 0,
      correctCount: correctCounts[item] || 0, // O의 개수가 없으면 0
      totalItemCount: itemCounts[item] || 0, // 전체 개수
    }));
  
    // 점수와 백분율 계산
    scoresByItemValue.forEach(entry => {
      entry.percentageByItem = entry.totalItemCount > 0
        ? ((entry.correctCount / entry.totalItemCount) * 100).toFixed(1) // 백분율 계산
        : 0; // 항목 데이터가 없는 경우 0
    });
  
    // 결과 정렬 (item 기준)
    scoresByItemValue.sort((a, b) => a.item.localeCompare(b.item));
  
    // 시각화에 사용할 데이터 변환
    const simplifiedData = scoresByItemValue.map(({ item, percentageByItem }) => {
      // dataListAvg에서 해당 item의 평균(avg)을 찾음
      const avgData = dataListAvg.find(avgItem => avgItem.item === item);
      return {
        name: item,
        점수: percentageByItem,
        평균: avgData ? avgData.avg.toFixed(1) : 0 // 평균이 없으면 기본값 0
      };
    });
  
    return simplifiedData;
  }
  
 

  //==================================================================================
  return (
    <div className="Chart_analysis">
      {dataList.length > 0 && (
        <section className="analysis-chart-card">
          <header className="analysis-chart-header">
            <span className="analysis-chart-header__icon">
              <FiBarChart2 aria-hidden="true" />
            </span>
            <div>
              <h1>영역별 성취도</h1>
            </div>
          </header>

          <div className="analysis-chart-legend" aria-label="차트 범례">
            <span><i className="is-score" />나의 점수</span>
            <span><i className="is-average" />전체 평균</span>
            <em>단위: 점</em>
          </div>

          <div
            className="chart-canvas"
            style={{ height: `${Math.max(18, dataList.length * 3.7 + 5)}rem` }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                layout="vertical"
                data={dataList}
                barCategoryGap="28%"
                barGap={4}
                margin={{ top: 8, right: 14, left: 0, bottom: 4 }}
              >
                <defs>
                  <linearGradient id="analysisScoreGradient" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#6252E8" />
                    <stop offset="100%" stopColor="#927CFF" />
                  </linearGradient>
                  <linearGradient id="analysisAverageGradient" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#35B9A1" />
                    <stop offset="100%" stopColor="#77D9C5" />
                  </linearGradient>
                </defs>
                <CartesianGrid horizontal={false} stroke="#E8EAF1" strokeDasharray="3 5" />
                <XAxis
                  type="number"
                  domain={[0, 100]}
                  ticks={[0, 25, 50, 75, 100]}
                  axisLine={false}
                  tickLine={false}
                  tick={{ fill: '#9299AA', fontSize: 11 }}
                />
                <YAxis
                  type="category"
                  dataKey="name"
                  width={66}
                  axisLine={false}
                  tickLine={false}
                  tick={{ fill: '#465067', fontSize: 12, fontWeight: 700 }}
                  tickFormatter={formatAreaName}
                />
                <Tooltip
                  content={<AnalysisTooltip />}
                  cursor={{ fill: 'rgba(101, 84, 232, 0.05)' }}
                />
                <Bar
                  dataKey="점수"
                  fill="url(#analysisScoreGradient)"
                  radius={[0, 8, 8, 0]}
                  maxBarSize={12}
                />
                <Bar
                  dataKey="평균"
                  fill="url(#analysisAverageGradient)"
                  radius={[0, 8, 8, 0]}
                  maxBarSize={12}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </section>
      )}
    </div>
  );
};

export default Chart_analysis;
